// const hostname = window.location.hostname;

// const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

// Base URL
export const BASE_URL = "https://prod-api.socialpawsapp.com";

export const ENDPOINTS = {
  GET_FEED_COMMENTS: (id) => `/feedComments/get-comments-by-feedId/${encodeURIComponent(id)}`,
  CREATE_FEED_COMMENT: "/feedComments/create-feed-comment",
  GET_FEED_BY_ID: (id) => `/feeds/get-feed-ById/${encodeURIComponent(id)}`,
  GET_ALL_FEEDS: "/feeds/get-all-feeds",
  CREATE_FEED: "/feeds/create-feed",
  // user registration
  REGISTER_USER: "/user/registerUser",

  // get user details by id
  GET_USER_DETAILS: (id) => `/user/details/${id}`,

  // dog registration
  REGISTER_DOG: "/dogs/create-dog",

  // user login
  LOGIN: "/user/login",

  // get nearBy dogs
  GET_NEARBY_DOGS: "/user/nerby-dogs-location",

  // create a webapp treat
  CREATE_WEBAPP_TREAT: "/webAppTreats/create-webapp-treat",

  // create a walk
  CREATE_A_WALK: "/bookwalks/create-walk",

  GENERATE_AI_BIO: "/openai/generate-ai-bio",

  GENERATE_AI_BIO_TEAMSOCIAL: "/openai/generate-ai-bio-for-teamsocial",

  GET_WEBAPP_FILTERS: "/webAppFilters",
};
